import moment from 'moment';
import { FE_ROUTES } from './Api';
import { BackgroundColors } from '@heartlandone/vega';
import copy from 'copy-to-clipboard';
import { getUserInfos, getAllDictType, getUserPermissions } from 'Chores/request';

export const getFromSessionStorage = (key) => {
  return sessionStorage.getItem(key) || '';
};

export const setFromSessionStorage = (key, value) => {
  sessionStorage.setItem(key, value);
};

export const getFromlocalStorage = (key) => {
  const value = localStorage.getItem(key);
  try {
    const valueObj = JSON.parse(value);
    if (!valueObj.expire || (valueObj.expire && valueObj.expire > Date.now())) {
      return valueObj[key] || '';
    }
    return '';
  } catch (error) {
    return value || '';
  }
};

export const setFromlocalStorage = (key, value, expire=0) => {
  const time = Date.now();
  const params = { [key]: value, expire: expire > 0 ? expire * 1000 + time : 0 };
  localStorage.setItem(key, JSON.stringify(params));
};

export const getUserAvatar = (userId) => {
  const userAvatar = getUserInfo(userId);

  let avatar = '';
  if (typeof userAvatar === 'object' && userAvatar.avatar !== null && userAvatar.avatar !== '') {
    avatar = userAvatar.avatar;
  } else {
    avatar = getDefaultUserAvatar();
  }

  return avatar;
};

export const getUserInfo = (userId) => {
  const allUserAvatar = getFromlocalStorage('allUserAvatar');
  return allUserAvatar[userId];
};

export const setAllUserAvatar = () => {
  getUserInfos().then((res) => {
    const allUserInfos= res.userInfos;
    const allUserAvatar = {};
    allUserInfos.map((item) => {
      allUserAvatar[item['userId']] = { userId: item['userId'], avatar: item['avatar'], name: item.name };
    });

    setFromlocalStorage('allUserAvatar', allUserAvatar);
  });
};

export const DICT_TYPE_CODE = {
  ProjectStatus: 'project-status',
  ProductLifecycle: 'product-lifecycle',
  SprintProgressStatus: 'sprint-progress-status',
  MarketCode: 'market-code',
  ProjectRole: 'project-role',
  Title: 'title',
  Location: 'location',
  RiskSeverity: 'risk-severity',
  RiskStatus: 'risk-status',
  CompanyName: 'company-name',
  SystemNotification: 'system-notification',
  ProjectNotification: 'project-notification',
  AssessmentCategory: 'assessment-category'
};

export const getDictDataNameById = (dictTypeCode, dictDataId) => {
  let dictDataName = '';
  const dictData = getDictType(dictTypeCode);

  if (dictData.length > 0) {
    const dictDataItem = dictData.find((item) => item.id == dictDataId);
    if (dictDataItem) {
      dictDataName = dictDataItem.name;
    }
  }

  return dictDataName;
};

export const getDictType = (dictTypeCode) => {
  const allDictType = getFromlocalStorage('allDictType');
  const dictType = allDictType.find((item) => item.code == dictTypeCode);

  let dictData = [];
  if (dictType && dictType.dictData !== null) {
    dictData = dictType.dictData;
  }

  return dictData;
};

export const setAllDictType = () => {
  getAllDictType().then((res) => {
    setFromlocalStorage('allDictType', res);
  });
};

export const setUserPermissions = (userId) => {
  const params = {
    userId: userId
  };

  getUserPermissions(params).then((res) => {
    setFromlocalStorage('userPermissions', res);
  });
};

export const checkPermissionForUserProject = (projectId, permission) => {
  const userPermissions = getFromlocalStorage('userPermissions');

  return !!(userPermissions?.projectPermissions.find((item) => item.projectId === projectId) || null)?.permissionItems.find((item) => item === permission);
};

export const getUserProjectIdsWithPermission = () => {
  const userPermissions = getFromlocalStorage('userPermissions');

  const projectIds = userPermissions?.projectPermissions.map((obj) => obj.projectId);
  return projectIds;
};

export const formatNumberWithCommasAndDecimals = (number) =>{
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(number);
};

// Convert the resource structure to the data source format used by the select component
export const loadResource = (resource, keys, setFunc, icon = false) => {
  const array = [];
  if (resource === null) return;

  resource.map((item) => {
    array.push({
      id: item[keys.id],
      displayName: item[keys.name],
      ...(icon && { prefixIcon: item[keys.icon] })
    });
  });

  setFunc(array);
};

export const menuHandle = (routerData = []) => {
  const arrayRouter = [];
  const flatData = (originalData, parentName) => {
    return originalData.map((item) =>
      item?.children?.length ?
        flatData(item.children, item.label) :
        arrayRouter.push({ ...item.extraProperties, menuNames: [parentName, item.label], newPath: item.newPath })
    );
  };
  flatData(routerData);
  return arrayRouter;
};

export const pathReplaceHandle = (res = [], label = '') => {
  const visibleNodes = [];
  res.forEach((item) => {
    const hidden = item?.extraProperties?.isHidden;
    if (hidden) {
      return;
    }
    item.newPath = `${label}/${item.key.replaceAll(' ', '-').toLocaleLowerCase()}`;
    if (item.children) {
      item.children = pathReplaceHandle(item.children, item.newPath);
    } else {
      item.selected = false;
    }
    visibleNodes.push(item);
  });
  return visibleNodes.sort((a, b) => a.order - b.order);
};

export const firstUpperCase = (str) => str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());

export const sortByDate = (arr = [], datePropName, asc = true) => {
  return arr.sort((a, b) => {
    const isSame = a[datePropName] === b[datePropName];
    const isBefore = moment(a[datePropName]).isBefore(b[datePropName]);
    if (isSame) return 0;
    if (asc) return isBefore ? -1 : 1;
    return isBefore ? 1 : -1;
  });
};

export const getBetweenDate = function(start, end, format = 'DD/MMM/YYYY') {
  const result = [];
  if (!start || !end) return result;
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();
  for (let s = startTime; s <= endTime;) {
    const day = moment(new Date(s)).format(format);
    result.push(day);
    s += 86400000;
  }
  return result;
};

export const dateTimeFormat = function(value, format = 'DD/MMM/YYYY') {
  return moment(value).format(format);
};

export const isInDateRange = (date, range = []) => range.length < 2 || moment(date).isBetween(...range, 'day', '[]');

export const filterByDateRange = (arr, datePropName, range) => arr.filter((item) => {
  const day = item[datePropName]?.replace(/T.*Z/, '');
  return moment(day).isValid() && isInDateRange(day, range);
});

export const barToHump = (str) =>
  str
    ?.split('-')
    ?.map((item) => firstUpperCase(item))
    ?.join('');

export const breadcrumbHandle = (path, menus) => {
  const projectHome = '/project-home';
  const lineInNames = ['gp-au/nz'];
  const menuLinks = menuHandle(menus);
  const menuObj = menuLinks.find(({ newPath }) => path.includes(newPath));
  const menuPaths = (menuObj?.newPath ?? '').split('/');
  const hasLine = lineInNames.some((name) => path.includes(name));
  const menuParentLink = menuPaths.slice(0, -1).join('/');
  const projectParentLink = menuPaths.slice(0, hasLine ? -3: -2).join('/');
  const hasProjectHome = path.includes(projectHome) ||
    menuParentLink && menuLinks.some(({ newPath }) => `${menuParentLink}${projectHome}` === newPath);
  let parentPath = `${FE_ROUTES.HOME}${ hasProjectHome ? projectParentLink : menuParentLink}`;
  const paths = path
    .replace(parentPath, '')
    .replace(projectHome, '')
    .substring(1).split('/')
    .reduce((list, str) => list.concat(
      hasLine && lineInNames.some((name) => name.includes(`/${str}`)) ? `${list.pop()}/${str}` : str || []
    ), [])
    .map((menu, index) => {
      parentPath = `${parentPath}/${menu}`;
      const link = `${parentPath}${index === 0 && hasProjectHome ? projectHome : ''}`;
      const title = menuObj?.menuNames[index] || menu.split('-').map((name) => firstUpperCase(name)).join(' ');
      return { link, title, name: menuObj?.menuNames[1] || title };
    });
  return new RegExp(`^${FE_ROUTES.HOME}/.+`).test(path) ?
    [{ link: FE_ROUTES.HOME, title: 'Home Page' }].concat(paths) : paths;
};

const DEPTH_ICON_RULES = {
  1: { parent: null, leaf: 'far fa-pager' },
  2: { parent: 'far fa-chart-tree-map', leaf: 'far fa-pager' },
  3: { parent: 'far fa-list-tree', leaf: 'far fa-square-poll-horizontal' },
  4: { parent: 'far fa-diagram-nested', leaf: 'far fa-square-poll-horizontal' },
  more: { parent: 'far fa-diagram-nested', leaf: 'far fa-square-poll-horizontal' }
};

const resolveDepthIcon = (depth, hasChildren) => {
  const rule = DEPTH_ICON_RULES[depth] || DEPTH_ICON_RULES.more;
  return hasChildren ? rule.parent : rule.leaf;
};

export const getMenuIcon = (res = [], depth = 1) => {
  res.forEach((item) => {
    const hasChildren = Array.isArray(item.children) && item.children.length > 0;
    const depthIcon = resolveDepthIcon(depth, hasChildren);

    if (depthIcon) {
      item.icon = depthIcon;
    }

    if (hasChildren) {
      getMenuIcon(item.children, depth + 1);
    }
  });
  return res;
};

export const filterMenuTree = (val, menu, newTree = []) => {
  const tree = JSON.parse(JSON.stringify(menu));
  if (!(tree.length && val)) {
    return tree;
  }
  for (const item of tree) {
    if (item.label.toLowerCase().includes(val.toLowerCase()) && item.nodeType === 3) {
      newTree.push(item);
      continue;
    }
    if (item.children && item.children.length) {
      const cacheTree = filterMenuTree(val, item.children);
      if (cacheTree && cacheTree.length) {
        const node = { ...item, children: cacheTree };
        newTree.push(node);
      }
    }
  }
  return newTree;
};

export const covertSprintDataForComboBox = (data) => {
  const sprints = [];
  const selectedSprintsKey = [];

  data.forEach(({ id, name, selected }) => {
    sprints.push({ key: id, label: name });

    if (selected) {
      selectedSprintsKey.push(id);
    }
  });

  return [sprints, selectedSprintsKey];
};

export const getDefaultUserAvatar=() => 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCABkAGQDASIAAhEBAxEB/8QAHQABAAEFAQEBAAAAAAAAAAAAAAUBAwQGBwIICf/EADQQAAEDAwEGBAQFBQEAAAAAAAEAAgMEBREGBxITITFRCEFhcSOBobEiJTJCUhVDYoLB8f/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD9U0REBeXyNjbl7g0dyVhV10bTZYzD5PoFCTVElQ7ekcXFBNS3qCPk3ekPoOSx3X537YQPdyiUQSovz884mn2KvRXyJ362OZ6jmFCIg2mGpiqBmN4d91dWpte5jg5pLSPMKUorwQQyfmP5oJhFQEOAIOQfNVQEREBR10uHAbwoz8QjmeyzKqcU0D5D5Dl7rWJJHSvc9xy4nJQUJycnmVREQERR931Da9PwiW53CmoIz0dUStZn2yeaCQRQdn11p3UEvCtt7oayXOOHFO0uPsM5KnEBERBI2u4GBwikOYz0J8lO9VqKn7RV8eDcccvZy9wgz0REERfZuccQP+R/4ohZl2fvV0npgfRYaAiIg0HbbtPi2UaFqrvutlrpDwKSF3R0pHIn0HX/ANXItA+HCq2kU8eqtplxra+urgJmW5spY2Jh5gOx0OPIYwsrxijgz7P6qqP5XDcyakEcsZjJz8gV9GUrmPpoXRkGMsBbjpjHJBwnVHg/0rU0pm0zPV6du0Q3oZ4pnPbvDpvAn7YV3w9bUr3XXm7aB1iS7UdnzuVLjk1EYPmfM4IIPmCu7L5prTFWeNegNuI3oLaRWlvTe4cmc/6lgQfSyIiAsu1zcGsZ2d+ErEVWuLXAjqDlBtqKjTvNB7jKINbuQxXTZ7rGWfeY9ytLvJwB/wCLAQEREGo7Vdn9u2l6Jr7LcXiBjxxIqk4+BI39L+fl39CV8zaA8T9fsinm0hqeNmqKK2v4EFytU7ZH7g6AEnDx2yQR0K2jaHqK+eIDaTPoDTdY+36at5/NK6PPxCORHqM8g3z6ldh0PsL0XoGhjhoLJTVFQAA+srIxNK898uzj2GAg4prTxxUX9NfFpewVYrpButqLtusZEe+6xzt72yFvHhl2dR2m21usbjdqe/6jvhL56ummErImkhxZvDlvZ645DAA6Lp1/2b6W1RRvprpYLfVxPGCXU7Q8ezgAQfUFfOer9HXfwq6gh1TpWonrdH1Mojr7ZM4uEWT3+zuo6HKD6vRR+nr7SamslDdaGQS0lXE2aNw7EdPcdFIICIvcMfFlYwfuICDaIRiFgP8AEIvQ5BEEde6fiQNkA5sPP2UGtse0PaWkZBGCtarKV1JOWHp1B7hBYUfqJ9THp+5uomOkrBTSmBjOrpN07oHzwpBEHFvCzoC5aK0ZcJ73QS0N5uFY+aZk4w/d6N+Xn812lEQFr+0HTserNFXq0SRcYVdK+NrMZ/ERyx65WwIg5J4YLLf9N7L4rVqKhnoKulqZGxRTjB4ZwR9crraIgKQs1PxKniEfhYPqsFjDI4NaMuPIBbJRUwpKdrP3dSfVBkIiICx6ykbVxbruRHQ9lkIg1aop300hY8YPfurS2menjqWbsjcj7KHqrNJESYviN7eaCORenscw4c0tPYheUBEVQMnAQUVWtL3ANBJPkFl09rnqCDu7je7lMUlvipBkDef/ACKCzbbaKYcSTnIfLspBEQEREBERAREQeXxskGHtDh6jKx3W2mf1haPbkiIKNtdK3+0PmSVfjp4ov0Rtb7BEQXEREBERAREQf//Z';

export const emailConvertLabel = (email) => email?.split('@')?.[0].split('.')?.join(' ');

export const fallbackText = (email) => emailConvertLabel(email)?.split(' ')?.map((item) => item?.[0]?.toLocaleUpperCase());

export const objectToQueryParams = (obj = {}) => {
  let queryParams = '';
  Object.keys(obj).forEach((item) => {
    queryParams += `&${item}=${obj[item]}`;
  });
  return queryParams.replace('&', '?');
};

export const parseQuery = (query = '') => {
  const obj = {};
  query = query.trim();
  if (query.indexOf('?') === 0) {
    query = query.substring(1);
  }
  const keyvalues = query.split('&');
  keyvalues.forEach((keyvalue) => {
    const keyvalueArr = keyvalue.split('=');
    obj[keyvalueArr[0]] = decodeURIComponent(keyvalueArr[1]);
  });
  return obj;
};

// common func
export const isEmptyGuid = (id) => {
  const GUIDEMPTY = '00000000-0000-0000-0000-000000000000';
  return id == GUIDEMPTY;
};

export const isUpdateSuccess = (res) => {
  // check update result by response
  return res.id && !isEmptyGuid(res.id);
};

export const copyToClipboard = (text, successTip='The text has been copied to clipboard.') => {
  if (copy(text)) {
    VegaNotify.open({
      type: 'success',
      message: successTip
    });
  }
};

export const objTree2list = (obj, childrenName='children') => {
  const list = [];
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      if (obj[key][childrenName]) {
        obj[key][childrenName] = objTree2list(obj[key][childrenName]);
      }
      list.push(obj[key]);
    }
  }
  return list;
};

export const objArrSort = (arr, key, order='ASC') => {
  arr?.sort((a, b) => {
    if (a[key] > b[key]) {
      return order === 'ASC' ? 1 : -1;
    } else if (a[key] < b[key]) {
      return order === 'ASC' ? -1 : 1;
    } else {
      return 0;
    }
  });
  return arr;
};

export const arr2obj = (arr, key) => {
  const obj = {};
  if (arr.length > 0) {
    arr.forEach((item) => {
      obj[item[key]] = item;
    });
  }
  return obj;
};

export const arr2ParentChildObj = (arr, key) => {
  const obj = {};
  if (arr.length > 0) {
    arr.forEach((item) => {
      if (obj[item[key]]) {
        obj[item[key]].push(item);
      } else {
        obj[item[key]] = [item];
      }
    });
  }
  return obj;
};

export const arr2vegaSelectSource = (arr, idKey='id', valueKey='name') => {
  const l = [];
  if (!Array.isArray(arr)) return [];
  if (arr.length > 0) {
    arr.forEach((item) => {
      if (item[valueKey] !== null && item[valueKey] !== '') {
        l.push({ id: item[idKey], displayName: item[valueKey] });
      }
    });
  }
  return l;
};

export const getShortName = (str) => {
  return str?.split(' ').map((item) => {
    return item?.slice(0, 1).toUpperCase();
  }).join('');
};

export const getBackgroundByShortName = (str) => {
  if (str) {
    const letter2num = { a: 1, b: 2, a: 1, c: 3, d: 4, e: 5, f: 6, g: 7, h: 8, i: 9, j: 10, k: 11, l: 12, m: 13, n: 14, o: 15, p: 16, q: 17, r: 18, s: 19, t: 20, u: 21, v: 22, w: 23, x: 24, y: 25, z: 26 };
    let total = 0;
    for (let index = 0; index < str.length; index++) {
      total += letter2num[str[index].toLowerCase()];
    }
    // use 40+ colors
    return BackgroundColors[total + 40];
  }
  return BackgroundColors[40];
};

export const removeTags = (str) => {
  if (str === null || str === '') return false;
  else str = str.toString();

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return str.replace(/(<([^>]+)>)/gi, '');
};

export const getDate = (strDate, separator='-') => {
  const date = new Date(strDate);
  const year = date.getFullYear();
  let month = date.getMonth();
  let dates = date.getDate();
  if (month < 10) month = '0' + month;
  if (dates < 10) dates = '0' + dates;
  return year + separator + month + separator + dates;
};

export const blob2Base64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const base64 = reader.result?.toString() || '';
      resolve(base64);
    });
    reader.addEventListener('error', () => {
      reject(new Error('Error converting blob to base64'));
    });
    reader.readAsDataURL(blob);
  });
};

export const zoomImage = (base64, w, callback, quality = 0.9) => {
  const newImage = new Image();
  newImage.src = base64;
  newImage.setAttribute('crossOrigin', 'Anonymous');
  newImage.onload = () => {
    const imgWidth = newImage.width;
    const imgHeight = newImage.height;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w;
        canvas.height = w * imgHeight / imgWidth;
      } else {
        canvas.height = w;
        canvas.width = w * imgWidth / imgHeight;
      }
    } else {
      canvas.width = imgWidth;
      canvas.height = imgHeight;
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height);
    const base64 = canvas.toDataURL('image/jpeg', quality);
    callback(base64);
  };
};

export const getGreeting = (time) => {
  if (time >= 0 && time < 12) {
    return 'Good morning';
  } else if (time >= 12 && time < 18) {
    return 'Good afternoon';
  } else {
    return 'Good evening';
  }
};

export const capitalizedName = (name) => {
  return name && name[0].toUpperCase() + name.substr(1);
};

export const specialCharacterTest = (str) => {
  return /[^ A-Za-z0-9\._-]/.test(str);
};
